export function RouteMethodNote({ compact = false }: { compact?: boolean }) {
  return (
    <aside className={`route-method-note${compact ? ' is-compact' : ''}`}>
      <div>
        <p className="eyebrow">How the route examples were made</p>
        <h2>
          {compact ? 'Real routes, clearly labeled.' : 'Built with the app’s bicycle router.'}
        </h2>
        <p>
          The examples use production-generated bicycle geometry—not hand-drawn marketing lines.
          Ahmed reviewed the endpoints, stage continuity, and displayed totals on 26 August 2026.
          Access and surface conditions can still change, so every route needs a fresh check before
          riding.
        </p>
        <a href="/route-methodology/">Read the short route methodology</a>
      </div>
      {!compact ? (
        <img
          src="/route-images/via-claudia-stages.png"
          width="1200"
          height="630"
          loading="lazy"
          alt="Production-generated Via Claudia bicycle route from Augsburg to Reschen Pass, shown as four connected stages"
        />
      ) : null}
    </aside>
  );
}
